import PrivateLibraryChart from "./PrivateLibraryChart";
import MyChartsPage from "../MyChartsPage/MyChartsPage";
import classes from "./LibraryPage.module.css";
import PublicLibrarySheet from "./PublicLibrarySheet";
import defaultLibraryQuery from "./defaultLibraryQuery";
import RenderData from "../../store/RenderData";
import UnpickleFromQueryString from "../../store/UnpickleFromQueryString";
import { useDispatch } from "react-redux";
import { mainActions } from "../../store";
import { useEffect, useRef, useState } from "react";
import library from "./library";
import { Helmet, HelmetProvider } from "react-helmet-async";
import LibraryMenu from "./LibraryMenu";
import { Link, Navigate, useLocation } from "react-router-dom";

const findLibraryEntry = (slug, liblist) => {
  for (let row = 0; row < liblist.length; row++) {
    if ("children" in liblist[row]) {
      let ret = findLibraryEntry(slug, liblist[row].children);

      if (ret !== null) return ret;
    } else {
      if (slug === liblist[row].slug) {
        return liblist[row];
      }
    }
  }
  return null;
};

const LibraryPage = () => {
  const [isBurgerMenu, setIsBurgerMenu] = useState(true);

  const dispatch = useDispatch();
  const { pathname, search, hash } = useLocation();
  const personal = pathname === "/library/my-charts";
  const savedId = pathname.startsWith("/library/saved/") ? pathname.slice("/library/saved/".length) : null;
  const publicPath = pathname.replace(/\/+$/, "");
  const entry = findLibraryEntry(publicPath.substring(1), library);
  const isRoot = publicPath === "/library";
  const isPublic = !personal && savedId === null;
  const source = isRoot ? defaultLibraryQuery : entry?.queryString;
  const [load, setLoad] = useState(null);
  // A route/source pair must finish loading before its sheet can mount.
  const current = load?.pathname === pathname && load.source === source ? load : null;
  const notFound = !isRoot && !entry;
  const loaded = current?.valid;
  const normalise = isPublic && (isRoot || entry) && publicPath !== pathname;
  const pageTitle = notFound ? "Collection not found | Guitar Charts"
    : current?.valid === false ? "Chart unavailable | Guitar Charts"
    : "Loading Library | Guitar Charts";

  const burgerWidth = 1125;
  useEffect(() => {
    const onResize = () => setIsBurgerMenu(window.innerWidth < burgerWidth);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!isPublic || notFound || normalise) return;
    const valid = UnpickleFromQueryString(source, dispatch);
    if (valid) dispatch(mainActions.setQueryString(source));
    setLoad({ pathname, source, valid });
  }, [dispatch, pathname, source, isPublic, notFound, normalise]);

  const [isOpen, setIsOpen] = useState(false);
  const drawer = useRef(null);
  useEffect(() => {
    const dialog = drawer.current;
    if (!dialog) return;
    if (isBurgerMenu && isOpen) dialog.showModal();
    else if (dialog.open) dialog.close();
    return () => { if (dialog.open) dialog.close(); };
  }, [isBurgerMenu, isOpen]);

  if (normalise) return <Navigate replace to={`${publicPath}${search}${hash}`} />;

  return (
    <div className={classes.container}>
      {isPublic && !loaded && <HelmetProvider><Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={notFound ? "The requested Library collection could not be found." : "The requested Library chart is not available yet."} />
        {(notFound || current?.valid === false) && <meta name="robots" content="noindex, follow" />}
      </Helmet></HelmetProvider>}
      {isBurgerMenu ? <>
        <div className={classes.mobileToolbar}>
          <button type="button" onClick={() => setIsOpen(true)} aria-haspopup="dialog" aria-expanded={isOpen}>Browse charts</button>
          <span>{personal ? "My Charts" : savedId !== null ? "Private chart" : entry?.name || "Library"}</span>
        </div>
        <dialog ref={drawer} className={classes.drawer} aria-label="Browse chart library"
          onCancel={() => setIsOpen(false)} onClose={() => setIsOpen(false)}
          onClick={event => { if (event.target === event.currentTarget) setIsOpen(false); }}>
          <div className={classes.drawerContent}>
            <button type="button" className={classes.closeButton} onClick={() => setIsOpen(false)}>Close library ×</button>
            <LibraryMenu onItemClicked={() => setIsOpen(false)} />
          </div>
        </dialog>
      </> : <aside className={classes.leftColumn}><LibraryMenu /></aside>}
      <div className={classes.rightColumn}>
        {personal ? <MyChartsPage /> : savedId !== null ? <><PrivateLibraryChart key={`${savedId}`} id={savedId} /><RenderData /></>
          : notFound || current?.valid === false ? <div className={classes.message} role="alert">
            <h1>{notFound ? "Collection not found" : "Chart unavailable"}</h1>
            <p>{notFound ? "We could not find the requested chart collection." : "This collection’s chart data could not be read. Please choose another collection or try again later."}</p>
            <Link to="/library">Back to the Library</Link>
          </div>
          : loaded ? <PublicLibrarySheet key={`${pathname}:${source}`} entry={entry} source={source} />
          : <p className={classes.message} role="status">Loading chart collection…</p>}

      </div>
    </div>
  );
};

export default LibraryPage;
